<template>
  <div class="flex items-start">
    <label class="switch">
      <input :checked="value" :disabled="disabled" type="checkbox" @change="$emit('input', !value)">
      <span class="slider round"></span>
    </label>
    <label v-if="label" :class="labelClass" class="ml-2 text-base font-light mb-1">{{ label }}<b
        v-if="isRequired" class="ml-1 text-red-600 font-bold">*</b> <span v-if="note" :class="noteClass">{{noteContent}}</span></label>
  </div>
</template>

<script>
export default {
  name: "Toggle",
  props: ["value", "label", "required", "leftIcon", "rightIcon", "labelClass", "rules", "name", "disabled", "note", "noteContent", "noteClass"],
  computed: {
    isRequired() {
      return this.required || this.rules?.search("required") > -1;
    }
  },

}
</script>

<style lang="scss">
/* The switch - the box around the slider */
$dot: 16px;
$width: $dot + 20;
.switch {
  position: relative;
  display: inline-block;
  width: $width;
  height: $dot+ 3;

  /* Hide default HTML checkbox */
  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background-color: #166AE0;
    }

    &:focus + .slider {
      box-shadow: 0 0 1px #166AE0;
    }

    &:checked + .slider:before {
      -webkit-transform: translateX($dot);
      -ms-transform: translateX($dot);
      transform: translateX($dot);
    }
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;

    &:before {
      position: absolute;
      content: "";
      height: $dot;
      width: $dot;
      left: 2px;
      bottom: 2px;
      background-color: white;
      -webkit-transition: .4s;
      transition: .4s;
    }

    /* Rounded sliders */
    &.round {
      border-radius: 36px;

      &:before {
        border-radius: 50%;
      }
    }
  }
}
</style>
